import React, {useMemo} from 'react';

const colors = ['#69D994', '#9DDEAD', '#B3E5C2', '#E5F6EB'];
const pendulumCount = 12;

const randRange = (min: number, max: number) => (
	Math.random() * (max - min) + min
);

const useSoftPendulums = () => (
	useMemo(() => {
		const generated: JSX.Element[] = [];
		for (let i = 0; i < pendulumCount; i++) {
			const anchorX = 10 + (i % 6) * 16;
			const anchorY = i < 6 ? 0 : 100;
			const direction = i < 6 ? 1 : -1;
			const length = randRange(20, 60);
			const circleSize = randRange(2, 5);
			const colorIndex = i % 4;
			const duration = randRange(8, 16);
			const delay = randRange(0, 3);
			const swingAngle = randRange(30, 60);

			// Pendulum line
			generated.push(
				<line
					key={`pendulum-line-${i}`}
					x1={anchorX}
					y1={anchorY}
					x2={anchorX}
					y2={anchorY + direction * length}
					stroke={colors[colorIndex]}
					strokeWidth='0.5'
					opacity='0.3'
				>
					<animateTransform
						attributeName='transform'
						type='rotate'
						values={`${-swingAngle} ${anchorX} ${anchorY};${swingAngle} ${anchorX} ${anchorY};${-swingAngle} ${anchorX} ${anchorY}`}
						dur={`${duration}s`}
						begin={`${delay}s`}
						repeatCount='indefinite'
						calcMode='spline'
						keySplines='0.42 0 0.58 1; 0.42 0 0.58 1'
					/>
				</line>
			);

			// Pendulum circle
			generated.push(
				<circle
					key={`pendulum-circle-${i}`}
					cx={anchorX}
					cy={anchorY + direction * length}
					r={circleSize}
					fill={colors[colorIndex]}
					opacity='0.8'
				>
					<animateTransform
						attributeName='transform'
						type='rotate'
						values={`${-swingAngle} ${anchorX} ${anchorY};${swingAngle} ${anchorX} ${anchorY};${-swingAngle} ${anchorX} ${anchorY}`}
						dur={`${duration}s`}
						begin={`${delay}s`}
						repeatCount='indefinite'
						calcMode='spline'
						keySplines='0.42 0 0.58 1; 0.42 0 0.58 1'
					/>
				</circle>
			);
		}
		return generated;
	}, [])
);

export const SoftPendulums: React.FC = () => {
	const elements = useSoftPendulums();
	return (
		<div>
			<svg
				width='100%'
				height='100%'
				viewBox='0 0 100 100'
				preserveAspectRatio='none'
			>
				{elements}
			</svg>
		</div>
	);
};
